import { render, staticRenderFns } from "./BrandingHeading.vue?vue&type=template&id=e38c533e&"
import script from "./BrandingHeading.vue?vue&type=script&lang=js&"
export * from "./BrandingHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports